import page from '../assets/index.json';

const path = '/assets/index.json';

export default {
  [path]: page,
};
